import { useTranslation } from "react-i18next";
import Marquee from "react-fast-marquee";

export const EditorialMarquee = () => {
  const { t } = useTranslation();
  const words = t("marquee.words", { returnObjects: true });

  return (
    <div data-testid="editorial-marquee" className="border-y border-white/5 py-8 select-none">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-2xl lg:text-3xl font-medium uppercase tracking-widest text-white/10 mx-8">
              {w}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-mint/30" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
